export default {
  path: '/v5/friend_codes',
  name: 'V5_friendcodes',
  component: () => import('./FriendCodesPage.vue'),
};
